<template>
    <v-app pb-3>
        <v-content>
            <v-container class="result-container">
                <v-layout
                    class="header-part"
                    row wrap
                >
                    <h1 v-if="policyType === 'OSAGO_NEW'">Полис ОСАГО оформлен</h1>
                    <h1 v-else>Полис Ипотечного страхования оформлен</h1>
                </v-layout>
                <div class="anim-this">
                    <div class="right-side">
                        <v-layout>
                            <h2>Ваш полис</h2>
                        </v-layout>
                        <v-layout
                            class="policy-part"
                            row wrap
                        >
                            <img
                                class="policy-logo"
                                :src="companyImage"
                                alt="img"
                            >
                            <p v-html="policyText"></p>
                            <p class="text-bold" v-html="policyText2"></p>
                        </v-layout>
                        <v-layout class="policy-text">
                            <v-flex lg6 md6 sm6 xs12>
                                <p>
                                    Оплата прошла успешно, полис будет отправлен вам на почту в течение 2 минут, кроме того,
                                    вы сможете скачать его в <a href="/dashboard">Личном кабинете</a>.
                                </p>
                                <p v-if="policyType === 'OSAGO_NEW'">
                                    Проверить подлиность вы всегда можете на сайте
                                    <a href="https://dkbm-web.autoins.ru/dkbm-web-1.0/bsostate.htm">РСА</a>.
                                </p>
                                <p v-if="policyType === 'OSAGO_NEW'">
                                    За месяц до окончания ОСАГО, мы предупредим о необходимости продления на почту или смс.
                                </p>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-btn
                                @click="toDashboard"
                                class="button"
                            >
                                Перейти в личный кабинет
                            </v-btn>
                        </v-layout>
                    </div>
                    <div class="green-circle">
                        <img class="circle-check" src="/svg/iconfinder-check.svg" alt="">
                    </div>
                </div>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
export default {
    props: [
        'companyImage',
        'policyText',
        'policyText2',
        'policyType',
    ],
    methods: {
        toDashboard() {
            window.location.replace('/dashboard');
        }
    },
}
</script>

<style scoped>

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFProBold', Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

/deep/ h2 {
    font-size: 28px;
    font-family: 'SFProBold', Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

a {
    color: #00ba57 !important;
    border-bottom: 1px solid #00a62a;
}

.result-container {
    max-width: 1240px;
    padding-top: 150px;
}

.header-part {
    margin-bottom: 74px;
}

.policy-part {
    margin-top: 50px;
    margin-bottom: 50px;
    column-gap: 70px;
    row-gap: 20px;
}

.policy-logo {
    width: 200px;
}

.text-bold {
    font-family: 'SFProBold', Arial, sans-serif;
    font-weight: 700;
}

.policy-text {
    font-size: 18px;
    line-height: 1.55;
}

.policy-text p {
    margin-bottom: 30px;
}

.button {
    color: #ffffff;
    font-size: 18px;
    text-transform: none;

    width: 320px;
    height: 70px;
    line-height: 1.55   ;
    background-color: #00ba57 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 35px;
    border-color: transparent;
    border-style: solid;

    padding: 10px 20px;
}

@keyframes opacityAnim {
    from {
        opacity: 0%;
    }

    to {
        opacity: 100%;
    }
}

@keyframes scaleCircle {
    from {
        transform: scale(0.7);
    }

    to {
        transform: scale(1);
    }
}

@keyframes moveRight {
    from {
        left: 0;
        right: 0;
    }

    /*to {
        left: 80%;
    }*/

    to {
        left: 80%;
    }
}

@keyframes opacityCheck {
    from {
        opacity: 0;
    }

    to {
        opacity: 100%;
    }
}

.right-side {
    animation: opacityAnim 0.5s ease-out 1.5s both;
}

.anim-this {
    position: relative;
}

.green-circle {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 235px;
    height: 235px;
    border-radius: 3000px;
    background-color: #00ba57;
    top: 0;
    bottom: 0;
    margin: auto;
    animation: scaleCircle 0.5s ease-in-out both, moveRight 0.5s ease-in-out both 1s;
    overflow: hidden;
}

.circle-check {
    width: 45%;
    animation: opacityCheck 0.5s ease both 0.5s;
}

@media (max-width: 1200px) {
    @keyframes moveRight {
        from {
            left: 0;
            right: 0;
        }
        to {
            left: 60%;
        }
    }
}

@media (max-width: 650px) {
    h1 {
        font-size: 45px;
    }

    .result-container {
        padding-top: 75px;
    }

    .policy-text p {
        font-size: 16px;
    }

    .green-circle {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/ResultComponent.vue